import { render, staticRenderFns } from "./modalDenegarPostulacion.vue?vue&type=template&id=4d30caa4&"
import script from "./modalDenegarPostulacion.vue?vue&type=script&lang=js&"
export * from "./modalDenegarPostulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports